export const 판매관리_플랫폼_액션_옵션_리스트 = [
  {
    label: '카페24',
    value: 'SETTLEMENT_ITEM-USAGE-TYPE_CAFE24',
  },
  {
    label: '네이버',
    value: 'SETTLEMENT_ITEM-USAGE-TYPE_NAVER',
  },
  {
    label: '번개장터',
    value: 'SETTLEMENT_ITEM-USAGE-TYPE_BUNJANG',
  },
  {
    label: '인스타그램',
    value: 'SETTLEMENT_ITEM-USAGE-TYPE_INSTAGRAM',
  },
  {
    label: '세컨솔드',
    value: 'SETTLEMENT_ITEM-USAGE-TYPE_SECONDSOLD',
  },
];
